import withStep from '@/containers/withStep';

import EntityTypeSelection from './variants/EntityTypeSelection';

export const VARIANTS = [EntityTypeSelection];

export default withStep('EntityTypeSelection', {
  id: 'entity-type-selection',
  description: 'Collects the merchants entity type',
  variants: VARIANTS,
});
